import React from "react";
import createSvgIcon from "@material-ui/icons/utils/createSvgIcon";

export default createSvgIcon(
  <React.Fragment>
    <path d="M13 4v7h7v2h-7v7h-2v-7H4v-2h7V4h2z" />
  </React.Fragment>,
  `AddIcon`
);
